import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[cpFileUpload]'
})
export class FileUploadDirective {
  @Output()
  fileDrop = new EventEmitter<FileList>();

  private inDragAreaCounter = 0;

  @HostBinding('class.mod-drop')
  get inDragArea() {
    return this.inDragAreaCounter !== 0;
  }

  @HostListener('dragenter', ['$event'])
  onDragEnter($event: DragEvent) {
    $event.preventDefault();
    this.inDragAreaCounter += 1;
  }

  @HostListener('dragover', ['$event'])
  onDragOver($event: DragEvent) {
    $event.preventDefault();
    if ($event.dataTransfer) {
      $event.dataTransfer.dropEffect = 'copy';
    }
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave($event: DragEvent) {
    this.inDragAreaCounter -= 1;
  }

  @HostListener('drop', ['$event'])
  onDrop($event: DragEvent) {
    $event.preventDefault();
    this.inDragAreaCounter = 0;
    if ($event.dataTransfer) {
      this.fileDrop.emit($event.dataTransfer.files);
    }
  }
}
